import React, { useEffect, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { authorization } from 'Module/Auth/Auth'
import PinUserIcon from 'Assets/Images/icons/pinUser'
import { getAmbassadorsLink } from 'Utils/Link'
import { futureMissionsCount } from 'Utils/Filters'
import { PATHS } from 'Config/Routing/paths'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import { AmbassadorWrapper } from 'Components/City/Page/Ambassador/AmbassadorWrapper'
import { PageTitle } from 'Components/PageTitle'
import * as CONST from 'Reducers/Ambassador/const'
import { ressetAmbassadorData } from './../../../../../Reducers/Ambassador/actions'
import { getClients } from 'Reducers/Clients/actions'
import { apiClient } from '../../../../../Module/API/Client'
import MerchandiseSection from '../Components/MerchandiseSection/container/MerchandiseSection'
import PowerBanksSection from '../Components/PowerBanksSection'
import SettingsSection from '../Components/SettingsSection/container/SettingsSection'
import { getBAName } from '../../../../../Utils/User'
import LegalDocumentsSection from '../Components/LegalDocumentsSection/container/LegalDocumentsSection'
import ContactDetailsSection from '../Components/ContactDetailsSection'
import IdentificationFilesSection from '../Components/IdentificationFilesSection'
import AmbassadorStatisticsSection from '../Components/StatisticsSection'
import ActivitySection from '../Components/ActivitySection'
import BankDetailsSection from '../Components/BankDetailsSection'
import { updateAmbassadorByIdGraphQL } from '../../../../../Reducers/Ambassador/actions'
import useGraphQLFetch from '../../../../../Utils/Hooks/useGraphQLFetch'
import {
  getBrandAmbassadorByID,
  refuseUser,
  updateUserDocument,
  readUserContract,
  readAllUserContracts,
  readAllUserContractAddendum,
  getDocumentAgreementContract,
} from '../gql'
import LoadingIndicator from '../../../../../Components/LoadingIndicator/LoadingIndicator'
import { getBrandAmbassadorActivity } from '../Components/ActivitySection/gql'
import { normalizeGraphQLConnection } from '../../../../../shared/graphql/utils'
import { getDocumentTypes } from 'Reducers/Document/actions'
import { COUNTRY_CODE, PAYROLL_PROVIDER_TYPES } from '../../../../../constants'
import OnSiteTrainingSection from '../Components/OnSiteTrainingSection/OnSiteTrainingSection'
import PreScreeningSection from '../Components/PreScreeningSection/PreScreeningSection'
import BlockingInfoSection from '../Components/BlockingInfoSection/BlockingInfoSection'
import {
  getTemplateDocumentName,
  getPayrollProviderData,
  groupContracts,
} from '../util'
import GermanyContractDataSection from '../Components/GermanyContractDataSection'
import BaPayslipsSection from '../Components/BaPayslipsSection'
import { AMBASSADOR_STATUS_KEY } from '../../../../../Reducers/Ambassador/const'
import { CONTRACT_TYPES_STRING } from '../../../../../shared/constants'
import UserRequestsSection from '../Components/UserRequestsSection'
import { StatusBadge } from 'Components/StatusBadge'
import { Box } from '@material-ui/core'
import NoShowTrackerSection from '../Components/NoShowTrackerSection'
import StyledBreadcrumbs from '../../../../../Components/StyledBreadcrumbs'
import { theme } from '../../../../../Assets/Styles/theme'

const Ambassador = props => {
  const { match } = props
  const {
    url,
    params: { ambassadorId },
  } = match
  const dispatch = useDispatch()
  const [isFadeLoading, setIsFadeLoading] = useState(false)
  const [isBaUpdating, setIsBaUpdating] = useState(false)
  const [fade, setFade] = useState(null)
  const [ambassador, setAmbassador] = useState({})
  const [missions, setMissions] = useState([])
  const [isLoadedMissions, setIsLoadedMissions] = useState(false)
  const [documentTypes, setDocumentTypes] = useState([])
  const [documents, setDocuments] = useState([])
  const [nmbrsDocument, setNmbrsDocument] = useState([])
  const [germanyContract, setGermanyContract] = useState(null)
  const [germanyPayroll, setGermanyPayroll] = useState(null)
  const [germanyContractData, setGermanyContractData] = useState(null)
  const [isGermanyContractLoading, setIsGermanyContractLoading] = useState(
    false,
  )
  const [documentAgreementContract, setDocumentAgreementContract] = useState(
    null,
  )
  const [baView, setBaView] = useState(false)
  const user = authorization.getUser()
  const {
    data,
    isLoading: isAmbassadorLoading,
    isLoaded,
    refetch,
  } = useGraphQLFetch({
    fetchFn: getBrandAmbassadorByID,
    defaultFetchArgs: { ambassadorId },
  })

  const {
    data: ambassadorContract,
    refetch: fetchAmbassadorContract,
    isLoading: isAmbassadorContractLoading,
  } = useGraphQLFetch({
    fetchFn: readUserContract,
    mapResponse: data =>
      data.readUserContract.url ? data.readUserContract : null,
  })

  const countryCode = ambassador.id ? ambassador.city.country.code : null

  const getContract = async () => {
    setIsGermanyContractLoading(true)

    const documentAgreementContract = await getDocumentAgreementContract({
      userId: ambassador.id,
    })

    if (documentAgreementContract) {
      setDocumentAgreementContract(documentAgreementContract)
    }
    if (ambassador.germanyContractData) {
      const allContracts = await readAllUserContracts({
        userId: ambassador.id,
      })

      const filteredContract = allContracts.filter(
        contract =>
          contract.templateDocument.name !== CONTRACT_TYPES_STRING.GPS,
      )

      const allContractIds = filteredContract.map(contract => contract.id)

      const getAllAddendums = async () => {
        let allAddendums = []

        for (const contractId of allContractIds) {
          const adds = await readAllUserContractAddendum({ contractId })
          allAddendums = [
            ...allAddendums,
            ...adds.map(add => ({ ...add, relatedContractId: contractId })),
          ]
        }

        return allAddendums
      }
      const allAddendums = await getAllAddendums()

      const signedAgreement = allContracts
        .filter(
          contract =>
            contract.templateDocument.name == CONTRACT_TYPES_STRING.GPS &&
            contract.signedAt,
        )
        .sort((a, b) => b.id - a.id)

      const contracts = groupContracts([...filteredContract, ...allAddendums])
      setGermanyContractData({
        ...contracts,
        agreement: signedAgreement[0],
      })
    }
    setIsGermanyContractLoading(false)
  }

  useEffect(() => {
    if (ambassador && ambassador.id) {
      getContract()
    }
  }, [ambassador])

  const isPayrollDataRequired = useMemo(
    () =>
      ambassador.id
        ? ambassador.payrollProvider === PAYROLL_PROVIDER_TYPES.NL_NMBRS &&
          ambassador.city.country.code === COUNTRY_CODE.NETHERLANDS &&
          ambassador.status == AMBASSADOR_STATUS_KEY.ACTIVE
        : false,
    [ambassador.id],
  )
  const isLoading = useMemo(
    () =>
      isPayrollDataRequired
        ? isAmbassadorLoading || isAmbassadorContractLoading
        : isAmbassadorLoading,
    [isAmbassadorLoading, isAmbassadorContractLoading, isPayrollDataRequired],
  )
  useEffect(() => {
    dispatch(getClients())
    dispatch(getDocumentTypes())
    getAllMissionsData()
    return () => dispatch(ressetAmbassadorData())
  }, [])

  const activitiesSortBy = useSelector(
    state => state.ambassadors.activitiesSortBy,
  )
  const activityStatus = useSelector(state => state.ambassadors.activityStatus)
  const documentTypesList = useSelector(
    state => state.document.documentTypesList,
  )

  useEffect(() => {
    if (ambassador.city && documentTypesList.length > 0) {
      const filteredList = documentTypesList.filter(
        doc =>
          doc.countryCode == ambassador.city.country.code &&
          doc.active &&
          !doc.ignoredCities.includes(Number(ambassador.city.id)),
      )
      setDocumentTypes(filteredList)
    }
  }, [ambassador, documentTypesList])

  const getAllMissionsData = async () => {
    let fetchArgs = { ambassadorId, first: 50 }
    const { data } = await getBrandAmbassadorActivity(fetchArgs)

    let ambassadorActivities = normalizeGraphQLConnection(
      data.brandAmbassador.missions,
    )
    let pageInfo = data.brandAmbassador.missions.pageInfo
    while (pageInfo.hasNextPage) {
      fetchArgs.after = pageInfo.endCursor
      const { data: newData } = await getBrandAmbassadorActivity(fetchArgs)
      pageInfo = newData.brandAmbassador.missions.pageInfo

      ambassadorActivities = [
        ...ambassadorActivities,
        ...normalizeGraphQLConnection(newData.brandAmbassador.missions),
      ]
    }

    setMissions(ambassadorActivities)
    setIsLoadedMissions(true)
  }

  const logsParams = type => ({
    input: {
      profile_user_id: +ambassadorId,
      actioned_by_user_id: +user.id,
      type,
    },
  })

  useEffect(() => {
    if (documentTypes && documentTypes.length > 0) {
      const documentsList = documentTypes.map(docType => {
        const userDocument = ambassador.documents.nodes.find(
          doc => Number(docType.id) == Number(doc.documentTypeId),
        )

        const uploader =
          userDocument && userDocument.uploader
            ? userDocument.uploader
            : ambassador.email
        return {
          ...userDocument,
          name: docType.name,
          uploader: userDocument ? uploader : null,
        }
      })
      setDocuments(documentsList)
    }
  }, [documentTypes])

  useEffect(() => {
    let nmbrsData = { userContract: ambassadorContract }
    if (
      ambassador.paymentProviderData &&
      ambassador.paymentDetails.accountNumber
    ) {
      nmbrsData = {
        ...nmbrsData,
        ...ambassador.paymentProviderData,
        ...ambassador.paymentDetails,
        name: 'First day at work',
        url: 'modal',
        isCustomData: true,
        uploader: ambassador.email,
      }
    } else {
      nmbrsData = {
        ...nmbrsData,
        name: 'First day at work',
        isCustomData: true,
      }
    }
    setNmbrsDocument(nmbrsData)
    setIsBaUpdating(false)
  }, [ambassador, ambassadorContract])

  const onRefuse = async () => {
    await refuseUser({ input: { id: ambassador.id } })
    refetch({ ambassadorId })
  }

  useEffect(() => {
    if (isLoaded && data) {
      setAmbassador(data.brandAmbassador)
    }
  }, [isLoaded])

  useEffect(() => {
    if (isPayrollDataRequired && ambassador.id) {
      fetchAmbassadorContract({
        userId: ambassador.id,
        contractName: getTemplateDocumentName(ambassador),
      })
    }
  }, [isPayrollDataRequired, ambassador])

  useEffect(() => {
    loadFadeValue()
  }, [ambassadorId])

  const {
    id,
    city,
    firstName,
    lastName,
    status,
    isNewcomer,
    isTeamLeader,
    blockedReason,
    onSiteTrainingInfo,
    blockedInfo,
  } = ambassador

  const teamLeaderEnabled = city && city.teamLeaderEnabled

  const userName = getBAName({
    firstName,
    lastName,
    isTeamLeader,
  })
  const ambassadorsPathname = getAmbassadorsLink(ambassador)

  const filterActivitiesByStatus = activities => {
    if (activityStatus) {
      return activities.filter(item => {
        return !activityStatus || activityStatus.indexOf(item.status) > -1
      })
    }
    return activities
  }

  async function handleUserActions({ status, blockedReason, unbookMissions }) {
    setIsBaUpdating(true)
    await dispatch(
      updateAmbassadorByIdGraphQL(
        ambassadorId,
        {
          statusV2: status,
          blockedReason,
          unbookMissions,
        },
        {
          onSuccess: () => {
            refetch({ ambassadorId })
            if (unbookMissions) {
              getAllMissionsData()
            }
          },
        },
      ),
    )
  }

  async function loadFadeValue() {
    if (!authorization.isAdmin() && !authorization.isCityManager()) return

    setIsFadeLoading(true)
    apiClient
      .getFadeValue(ambassadorId)
      .then(result => {
        setIsFadeLoading(false)
        setFade(result.fade)
      })
      .catch(err => {
        console.error(err)
        setIsFadeLoading(false)
      })
  }

  async function onFadeChange() {
    const shouldFade = !fade

    setIsFadeLoading(true)
    apiClient
      .setFadeValue(ambassadorId, shouldFade)
      .then(result => {
        setIsFadeLoading(false)
        setFade(result.fade)
      })
      .catch(err => {
        console.error(err)
        setIsFadeLoading(false)
      })
  }

  const statusHTML = useMemo(() => {
    var statusID = status

    if (
      status == 'blocked' &&
      futureMissionsCount(missions, 'timeRangeStart')
    ) {
      statusID = 'terminating'
    }

    return (
      status && (
        <span className="status">
          ({CONST.AMBASSADOR_STATUS_LABEL[statusID]})
        </span>
      )
    )
  }, [ambassadorId, status, missions.length])

  const signedLegalDocuments = useMemo(() => {
    let documents = []
    if (ambassador.id) {
      documents = ambassador.signedLegalDocuments.edges.map(({ node }) => ({
        ...node.legalDocument,
        dateTime: node.dateTime,
      }))
      if (ambassadorContract) {
        // Adding staff.userContract to the signed document list
        documents.push({
          name: `${
            getPayrollProviderData({
              ambassador,
            }).payrollProviderName
          } Contract`,
          dateTime: ambassadorContract.signedAt,
          url: ambassadorContract.url,
        })
      }
    }
    return documents
  }, [ambassador, ambassadorContract])

  if (!id) return null

  const onDocumentUpdate = async input => {
    try {
      await updateUserDocument({ input })
    } catch (error) {
      /* eslint-disable */
      console.log({ error })
    }
  }

  const showOnSiteTrainingBlock = onSiteTrainingInfo.rating

  const showBlockingInfo = status === 'blocked' && blockedInfo.created_at
  const showGermanyContractData =
    ambassador.id &&
    ambassador.city.country.code == COUNTRY_CODE.GERMANY &&
    !authorization.isCityManagerAssistant()

  const showNoticePeriod = ambassador.isNoticePeriod

  const breadcrumbs = [
    { label: 'Dashboard', link: PATHS.main.dashboard },
    {
      label: 'Cities',
      link: `${PATHS.main.dashboard}${PATHS.dashboard.cities}`,
    },
    {
      label: city.name,
      link: `${PATHS.main.dashboard}${PATHS.dashboard.cities}/${
        city ? city.id : null
      }${PATHS.cities.masterSchedule}`,
    },
    { label: 'Brand Ambassadors', link: ambassadorsPathname },
    {
      label: `${firstName} ${lastName}`,
      link: url,
    },
  ]

  const canSeeSensitiveData = !authorization.isCityManagerAssistant()

  return (
    <HideWhenBlocked>
      <AmbassadorWrapper>
        <StyledBreadcrumbs
          icon={
            <PinUserIcon style={{ width: 16, fill: theme.colors.primary }} />
          }
          breadcrumbs={breadcrumbs}
        />
        <Box display="flex" alignItems="center" gridGap={20}>
          <PageTitle>
            {userName}
            {statusHTML}
            {isNewcomer && (
              <div
                style={{ float: 'right', lineHeight: '34px', fontSize: '16px' }}
              >
                <span role="img" aria-label="warning">
                  ⚠️
                </span>
                Newcomer
                <span role="img" aria-label="warning">
                  ⚠️
                </span>
              </div>
            )}
          </PageTitle>

          {showNoticePeriod && (
            <StatusBadge variant="danger">Notice period</StatusBadge>
          )}
        </Box>
        {isLoading ? (
          <LoadingIndicator />
        ) : (
          <div>
            <ContactDetailsSection
              ambassador={ambassador}
              onRefuse={onRefuse}
              city={city}
              isBaUpdating={isBaUpdating}
              handleUserActions={handleUserActions}
              onFadeChange={onFadeChange}
              isFadeLoading={isFadeLoading}
              fade={fade}
              documents={documents}
              nmbrsDocument={nmbrsDocument}
              germanyContract={germanyContract}
              germanyPayroll={germanyPayroll}
              documentTypes={documentTypes}
              missions={missions}
              setBaView={setBaView}
              baView={baView}
            />
            {showBlockingInfo && (
              <BlockingInfoSection
                data={{
                  blockedReason,
                  ...blockedInfo,
                  timezone: ambassador.city.timezone,
                }}
              />
            )}
            {ambassador.preScreening && (
              <PreScreeningSection data={ambassador.preScreening} />
            )}
            {showOnSiteTrainingBlock && (
              <OnSiteTrainingSection data={onSiteTrainingInfo} />
            )}
            {showGermanyContractData && (
              <GermanyContractDataSection
                contractData={germanyContractData}
                refetchAmbassadorData={() => refetch({ ambassadorId })}
                ambassador={ambassador}
                isDataLoading={isGermanyContractLoading}
              />
            )}
            {showGermanyContractData && (
              <BaPayslipsSection ambassador={ambassador} />
            )}
            {canSeeSensitiveData && (
              <UserRequestsSection
                ambassador={ambassador}
                documentTypes={documentTypes}
                isDocumentManagementEnabled={city.isBaDocumentManagementEnabled}
                countryCode={countryCode}
              />
            )}
            {canSeeSensitiveData && (
              <IdentificationFilesSection
                ambassador={ambassador}
                city={city}
                documentTypes={documentTypes}
                documents={documents}
                updateUserDocument={onDocumentUpdate}
                setDocuments={setDocuments}
                nmbrsDocument={nmbrsDocument}
                setNmbrsDocument={setNmbrsDocument}
                setGermanyContract={setGermanyContract}
                setGermanyPayroll={setGermanyPayroll}
                user={user}
              />
            )}
            <NoShowTrackerSection ambassador={ambassador} />
            <SettingsSection
              ambassador={ambassador}
              teamLeaderEnabled={teamLeaderEnabled}
              logsParams={logsParams}
            />
            <MerchandiseSection ambassadorId={ambassadorId} />
            <PowerBanksSection ambassador={ambassador} />
            <AmbassadorStatisticsSection
              isLoadedMissions={isLoadedMissions}
              missions={missions}
              ambassador={ambassador}
            />
            {!authorization.isCityManagerAssistant() ? (
              <BankDetailsSection
                ambassador={ambassador}
                logsParams={logsParams}
              />
            ) : null}
            <ActivitySection
              isLoadedMissions={isLoadedMissions}
              missions={missions}
              match={match}
              filterActivitiesByStatus={filterActivitiesByStatus}
              activitiesSortBy={activitiesSortBy}
              baView={baView}
            />
            {signedLegalDocuments && (
              <LegalDocumentsSection
                signedLegalDocuments={signedLegalDocuments}
                formW9={ambassador.formW9}
                gpsAgreement={
                  germanyContractData ? germanyContractData.agreement : null
                }
                timezone={ambassador.city.timezone}
                documentAgreementContract={documentAgreementContract}
                countryCode={countryCode}
              />
            )}
          </div>
        )}
      </AmbassadorWrapper>
    </HideWhenBlocked>
  )
}

export default withRouter(Ambassador)
